<template>
  <div>
    <child-development-child-container />
  </div>
</template>
<script lang="ts">
import { defineComponent } from "vue";

import ChildDevelopmentChildContainer from "@/containers/child-development/ChildDevelopmentChildContainer.vue";

export default defineComponent({
  components: {
    ChildDevelopmentChildContainer,
  },
});
</script>
